
import { useEffect, useState } from 'react';

/**
 * Hook that detects if debug mode is enabled via URL query parameter
 * or if running in Lovable environment
 * @returns A boolean indicating if debug mode is enabled
 */
export const useDebugMode = (): boolean => {
  const [isDebugMode, setIsDebugMode] = useState<boolean>(false);
  
  useEffect(() => {
    // Check if running in Lovable environment (expanded to include more Lovable domains)
    const isInLovable = window.location.hostname.includes('lovable.app') || 
                        window.location.hostname.includes('lovable.dev') || 
                        document.referrer.includes('lovable.app') ||
                        document.referrer.includes('lovable.dev') ||
                        window.location.search.includes('lovable_preview=true');
    
    // Check for debug parameter in URL
    const queryParams = new URLSearchParams(window.location.search);
    const debugParam = queryParams.get('debug');
    
    // Debug mode is enabled if:
    // - Explicitly set via URL parameter, OR
    // - Running on a Lovable domain AND not explicitly disabled
    setIsDebugMode(
      debugParam === 'true' || 
      (isInLovable && debugParam !== 'false')
    );
    
    // Update debug mode if URL changes
    const handleUrlChange = () => {
      const params = new URLSearchParams(window.location.search);
      const debugParamUpdated = params.get('debug');
      setIsDebugMode(
        debugParamUpdated === 'true' || 
        (isInLovable && debugParamUpdated !== 'false')
      );
    };
    
    window.addEventListener('popstate', handleUrlChange);
    
    return () => {
      window.removeEventListener('popstate', handleUrlChange);
    };
  }, []);
  
  return isDebugMode;
};
